import React from "react";

export default function UploadItemsHeader({ mode, setMode }) {
    const title =
        mode === "single"
            ? "Add Single Catalogue Item"
            : mode === "bulk"
                ? "Bulk Upload"
                : "Extract Catalogue From Image";

    const tabs = [
        { key: "single", label: "Single" },
        { key: "bulk", label: "Bulk" },
        { key: "extract", label: "Extract" },
    ];

    return (
        <div className="sticky top-0 z-30">
            <div className="flex items-center justify-between gap-3 rounded-lg border bg-white px-3 py-1.5 shadow-sm">
                <div className="flex min-w-0 items-center gap-2">
                    <span className="h-2 w-2 shrink-0 rounded-full bg-green-500" />

                    <h1 className="truncate text-sm font-bold text-gray-900 montserrat-font-1">
                        {title}
                    </h1>

                    <span className="hidden text-[11px] text-gray-400 sm:inline">
                        · Catalogue Items Control Panel
                    </span>
                </div>

                <div className="flex shrink-0 items-center rounded-full border bg-gray-50 p-0.5">
                    {tabs.map((tab) => (
                        <button
                            key={tab.key}
                            type="button"
                            onClick={() => setMode(tab.key)}
                            className={`rounded-full px-3 py-0.5 text-[11px] font-semibold transition ${
                                mode === tab.key
                                    ? "bg-green-600 text-white shadow-sm"
                                    : "text-gray-500 hover:text-green-600"
                            }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}